/**
 * Minimum ms between a click track and the screen *Viewed.
 * App: `waitForSegmentEventSpacing()` waits this long before navigate.
 * Tune here until Segment persists order reliably without unnecessary wait.
 */
export const SEGMENT_INTERACTION_MIN_GAP_MS = 800

export const SEGMENT_EVENT_SPACING_FN = 'waitForSegmentEventSpacing' as const

export const waitForSegmentEventSpacing = (): Promise<void> =>
  new Promise(resolve => {
    window.setTimeout(resolve, SEGMENT_INTERACTION_MIN_GAP_MS)
  })
